import React, { useState } from "react";
import "../App.css";
import { Grid, Container } from "@mui/material/";
import BasicTabs from "../components/TabComponent";
import MapComponent from "../components/Map";
import GridAutoComplete from "../components/GridAutoComplete";
import { Navigate } from "react-router-dom";

function MeasureOverview(props) {
  const MeasureData = JSON.parse(sessionStorage.getItem('measureTable')) ;//FetchRequest("measureTable");
  

  // Hook to store the information about the currently selected country
  const [country, setCountry] = useState("none");
  // Function that will pull the selected country from the child component
  const pull_data = (data) => {
    if (data === sessionStorage.getItem("country")) {
      setCountry("none");
      sessionStorage.setItem("country", "none");
    } else if (data !== sessionStorage.getItem("country")) {
      setCountry(data);
      sessionStorage.setItem("country", data);
    } else if (data === "none") {
      sessionStorage.setItem("country", "none");
    }
  };

  // Get passthrough to check wether or not the map is minimalized
  const [mapMinizaledHome, setMapMinizaledHome] = useState();
  const pullMinimalized = (data) => {
    setMapMinizaledHome(data);
  };

  // Get the id of the selected row
  const [selectedRow, setSelectedRow] = useState();
  const getSelectedRows = (data) => {
    setSelectedRow(data);
  };

  // Get the selected Category from Autocomplete
  const [selectedCat, setSelectedCat] = useState();
  const getSelectedCat = (data) => {
    setSelectedCat(data);
  };

  // Get the selected Subcategory from Autocomplete
  const [selectedSubCat, setSelectedSubCat] = useState();
  const getSelectedSubCat = (data) => {
    setSelectedSubCat(data);
  };

  // Get the selected Specific Measures from Autocomplete
  const [selectedMeas, setSelectedMeas] = useState();
  const getSelectedMeas = (data) => {
    setSelectedMeas(data);
  };

  // Get the selected Specific Measures from Autocomplete
  const [selectedTitle, setSelectedTitle] = useState();
  const getSelectedTitle = (data) => {
    setSelectedTitle(data);
  };

  // Switch from table/map to measure page when measure in table is clicked
  function renderSwitch(param) {
    let boolInteger = param !== undefined ? true : false;
    switch (boolInteger) {
      case true:
        return (
          //   changed this so it navigates to a separate measure page, rather than staying on the home ('/') page
          <Navigate to={`/measure/${param}`} />
        );
      default:
        return (
          <>
            <Container maxWidth={false}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <GridAutoComplete
                    selectedCountry={country}
                    MeasureData={MeasureData}
                    selectedTitle={getSelectedTitle}
                    selectedCat={getSelectedCat}
                    selectedSubCat={getSelectedSubCat}
                    selectedMeas={getSelectedMeas}
                  />
                </Grid>
                <Grid item lg={mapMinizaledHome ? 11 : 6} xs={12}>
                  <BasicTabs
                    selectedRows={getSelectedRows}
                    mapMinimalized={mapMinizaledHome}
                    selectedCountry={country}
                    selectedCat={selectedCat}
                    selectedSubCat={selectedSubCat}
                    selectedMeas={selectedMeas}
                    selectedTitle={selectedTitle}
                  />
                </Grid>

                <Grid
                  item
                  lg={mapMinizaledHome ? 1 : 6}
                  xs={12}
                  sx={{ height: "68vh" }}
                >
                  <MapComponent
                    mapMinimalized={pullMinimalized}
                    selectedCountry={pull_data}
                    giveSelectedCountry={country}
                  />
                </Grid>
              </Grid>
            </Container>
          </>
        );
    }
  }

  return <>{renderSwitch(selectedRow)}</>;
}

export default MeasureOverview;
